import { createSlice } from "@reduxjs/toolkit";
import { DocumentTypeDTO } from "../../models/BookkeepingDocument.model";
import { loginUser } from "../thunks/authThunks";
import { refreshCompanyData } from "../thunks/companyDataThunks";

interface DocumentTypesState {
  documentTypes: DocumentTypeDTO[];
  loading: boolean;
  error: string | null;
  initialized: boolean;
}

const initialState: DocumentTypesState = {
  documentTypes: JSON.parse(sessionStorage.getItem("documentTypes") || "[]"),
  loading: false,
  error: null,
  initialized: !!sessionStorage.getItem("documentTypes"),
};

const documentTypesSlice = createSlice({
  name: "documentTypes",
  initialState,
  reducers: {
    // פעולה לניקוי השגיאות
    clearError: (state) => {
      state.error = null;
    },
    // פעולה לניקוי הנתונים (למשל בעת logout)
    clearDocumentTypes: (state) => {
      state.documentTypes = [];
      state.loading = false;
      state.error = null;
      state.initialized = false;
      sessionStorage.removeItem("documentTypes");
    },
    // ניקוי בשינוי חברה - סוגי מסמכים תלויים בחברה
    clearDocumentTypesOnCompanyChange: (state) => {
      state.documentTypes = [];
      state.initialized = false;
      state.error = null;
      sessionStorage.removeItem("documentTypes");
    },
  },
  extraReducers: (builder) => {
    builder
      // האזנה לאימות מוצלח - טעינה ראשונית
      .addCase(loginUser.fulfilled, (state, action) => {
        const { documentTypes } = action.payload;

        if (documentTypes && documentTypes.length > 0) {
          state.documentTypes = documentTypes;
          state.initialized = true;
          state.error = null;
          sessionStorage.setItem(
            "documentTypes",
            JSON.stringify(documentTypes)
          );
        }
      })
      // האזנה לרענון נתוני חברה
      .addCase(refreshCompanyData.fulfilled, (state, action) => {
        const { documentTypes } = action.payload;
        if (documentTypes && documentTypes.length > 0) {
          state.documentTypes = documentTypes;
          state.initialized = true;
          state.error = null;
          sessionStorage.setItem(
            "documentTypes",
            JSON.stringify(documentTypes)
          );
        }
      })
  },
});

export const {
  clearError,
  clearDocumentTypes,
  clearDocumentTypesOnCompanyChange,
} = documentTypesSlice.actions;

export default documentTypesSlice.reducer;
